module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-576.56d8594.woff2";